import React, { FC } from 'react';
import { Select as AntdSelect } from 'antd';
import BEMHelper from 'react-bem-helper';

import { ISelectProps } from './interfaces';

import './styles.scss';

const classes = new BEMHelper({
  name: 'select',
  outputIsString: true,
});

const Select: FC<ISelectProps> = ({
  className,
  disabled = false,
  error = false,
  children,
  ...otherProps
}) => (
  <AntdSelect
    {...otherProps}
    disabled={disabled}
    className={`${className} ${classes('', { error })}`}
  >
    {children}
  </AntdSelect>
);

export default Select;
